import * as React from "react";
import styled, { css } from "../../../styled/index";
import { InputGroup } from "../input.group/index";
import { FaExclamationCircle } from "react-icons/fa";
import lighten from "polished/lib/color/lighten";
import {CS} from "../../../styles/index";
import {shadeAlternate} from "../../../styled/helpers";

export interface FormGroupComponentProps {
  no_border?: boolean;
  not_last?: boolean;
}
const FormGroupComponent = styled("div")<FormGroupComponentProps>`
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px dashed ${({theme}) => theme.input.border};
  &:only-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  ${(props) => props.no_border ? css`
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
    }
  ` : ""};
  ${(props) => props.not_last ? css`
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px dashed ${({theme}) => theme.input.border};
  ` : ""};
`;

const FormGroupLabel  = styled("div")<{ small_title?: boolean; }>`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  > .title {
    font-size: ${({theme, small_title}) => theme.input.fontSize + (small_title ? 0 : 2)}px;
    line-height: ${({theme}) => theme.input.fontSize + 8}px;
    font-weight: 600;
  }
  > .optional {
    padding: 3px 5px;
    border: 1px solid ${({theme}) => shadeAlternate(0.5, theme.colors.text)};
    color: ${({theme}) => shadeAlternate(0.25, theme.colors.text)};
    font-size: ${({theme}) => theme.input.fontSize - 2}px;
    font-weight: 600;
    border-radius: 5px;
    text-transform: uppercase;
  }
`;

const FormGroupContent = styled("div")``;

const FormGroupHelp = styled("span")`
  display: block;
  margin-top: 10px;
  font-size: ${({theme}) => theme.input.fontSize}px;
  line-height: ${({theme}) => theme.input.fontSize + 8}px;
`;

const FormGroupError = styled("span")`
  ${CS.flex.line_center};
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.3;
  color: ${({theme}) => theme.colors.error};
  background: ${({theme}) => lighten(0.43, theme.colors.error)};
  padding: 5px 10px;
  border-radius: 3px;
`;

export interface FormGroupProps {
  hide?: boolean;
  title?: string | React.ReactNode;
  small_title?: boolean;
  help?: string | React.ReactNode;
  className?: string;
  contentClassName?: string;
  contentInline?: boolean;
  children?: React.ReactNode;
  no_border?: boolean;
  not_last?: boolean;
  error?: string | React.ReactNode | null;
  style?: React.CSSProperties;
  optional?: boolean;
}

export class FormGroup extends React.Component<FormGroupProps> {

  render() {
    const { props } = this;
    if (props.hide)
      return null;
    return (
        <FormGroupComponent
          style={props.style}
          className={props.className}
          no_border={props.no_border}
          not_last={props.not_last}>

        <div className={props.contentInline ? "flex-l-r-center" : ""}>

          {(props.title || props.optional) && (
            <FormGroupLabel small_title={props.small_title}>
              {props.title && <label className="title">{props.title}</label>}
              {props.optional && (<span className="optional">Optional</span>)}
            </FormGroupLabel>
          )}

          <FormGroupContent className={props.contentClassName}>
            {props.children}
          </FormGroupContent>

        </div>

        {props.help && <FormGroupHelp>{props.help}</FormGroupHelp>}
          {props.error &&
            <FormGroupError>
              <FaExclamationCircle className="m-r-2"/>
              <span>{props.error}</span>
            </FormGroupError>
          }

      </FormGroupComponent>
    );
  }

}

export interface FormGroupIconProps extends FormGroupProps {
  icon?: React.ReactNode;
  icon_html?: React.ReactNode;
  icon_style?: React.CSSProperties;
  icon_class?: string;
}

export class FormGroupIcon extends React.PureComponent<FormGroupIconProps> {
  render() {
    const { props } = this;
    if (props.hide)
      return null;
    return (
      <FormGroupComponent
        style={props.style}
        className={props.className}
        no_border={props.no_border}
        not_last={props.not_last}>

        {props.title && <FormGroupLabel small_title={props.small_title}>{props.title}</FormGroupLabel>}

        <FormGroupContent className={props.contentClassName}>
          <InputGroup
            icon={props.icon}
            iconHtml={props.icon_html}
            className={props.icon_class}
            iconStyle={props.icon_style}>
            {props.children}
          </InputGroup>
        </FormGroupContent>

        {props.help && <FormGroupHelp>{props.help}</FormGroupHelp>}

      </FormGroupComponent>
    );
  }
}
